import * as React from 'react';
import classNames from 'classnames';

import styles from '../less/action/index.module.less';

interface ComponentProps {
  track;
  addClass?: boolean;
}

const ClickCollector: React.FunctionComponent<ComponentProps> = ({
  children,
  track,
  addClass = false
}) => {
  const captureEventHandler = (event) => {
    if (event.target.tagName === 'A' || event.target.tagName === 'BUTTON') {
      track({
        eventLabel: event.target.innerText
      });
    }
  };

  return (
    <div
      onClickCapture={captureEventHandler}
      className={classNames({ [styles.gjeActionGroup]: addClass })}
    >
      {children}
    </div>
  );
};
export default ClickCollector;
